import type { BadgeVariant } from '@fp/ui-kit'

const PHASE_BADGE_VARIANTS: Record<string, BadgeVariant> = {
  student: 'info',
  practitioner: 'success',
  senior: 'highlight',
  master: 'neutral',
}

export const getPhaseBadgeVariant = (phase?: string | null): BadgeVariant =>
  (phase && PHASE_BADGE_VARIANTS[phase]) || 'fresh'
